import { render, staticRenderFns } from "./Identificacion.vue?vue&type=template&id=7ec99800&"
import script from "./Identificacion.vue?vue&type=script&lang=js&"
export * from "./Identificacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/tempos21/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('7ec99800', component.options)
    } else {
      api.reload('7ec99800', component.options)
    }
    module.hot.accept("./Identificacion.vue?vue&type=template&id=7ec99800&", function () {
      api.rerender('7ec99800', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Modules/Map/DetailsResidencial/Identificacion.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/Map/DetailsResidencial/Identificacion.vue
// module id = xKJa
// module chunks = 0